<template>
  <div class="highchart-container">
    <div :id="props.domId" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script setup>
import { onMounted, watch } from "vue";
import Highcharts from "highcharts";

const props = defineProps({
  domId: { type: String, required: true },
  seriesData: { type: Array, required: true }, // Pass actual pie/donut chart data
  colour: { type: Array, required: true }, // Pass actual pie/donut chart data
  title: { type: String, default: "" },
  subtitle: { type: String, default: "" },
});

const renderChart = () => {
  Highcharts.chart(props.domId, {
    chart: {
      type: "pie",
      height: 250,
    },
    title: { text: props.title },
    subtitle: { text: props.subtitle },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        colors: props.colour,
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.y}",
        },
      },
    },
    series: [
      {
        name: "Amount",
        colorByPoint: true,
        data: props.seriesData,
      },
    ],
  });
};

onMounted(() => {
  renderChart();
});

watch(
  () => props.seriesData,
  () => {
    renderChart();
  }
);
</script>

<style scoped>
.highchart-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
